module.exports = __webpack_public_path__ + "img/seo.e4a41956.jpg";